import { uploadDeparturesData } from '../../_services/departures.service';

export const uploadDeparturesDataEvent = async (bytes, extension, type, date_created) => {
    let res = await uploadDeparturesData(bytes, extension, type, date_created);
    if(! res.ok){
        throw new Error(res.error);
    }     
    return res.data.result;
}